import BaseComponent from '../abstracts/BaseComponent';

export default class HeaderContainer extends BaseComponent {
  get Messages() {
    return {
      [this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.open]: this.onOpen,
      [this.CUSTOM_MESSAGES.DROPDOWN_EVENTS.close]: this.onClose
    };
  }

  constructor(element) {
    super(element);
    this.preHeader = element.querySelector('.pre-header');
    this.header = element.querySelector('header');
  }

  onOpen(e) {
    console.log('onOpen', 'e.triggerSelector', e.triggerSelector);
    if (e.triggerSelector !== 'js-fairs-calendar-trigger') {
      return;
    }
    this.preHeader.style.zIndex = '1';
  }

  onClose(e) {
    console.log('onClose', 'e.triggerSelector', e.triggerSelector);
    if (e.triggerSelector !== 'js-fairs-calendar-trigger') {
      return;
    }
    this.preHeader.style.zIndex = '';
  }
}
